let scriptLoaded = false;

// eslint-disable-next-line import/prefer-default-export
export function loadOrUpdateEqualWeb({
  hideBtn,
  position,
  lang,
  sitekey,
}: {
  hideBtn: boolean;
  position: string;
  lang: string;
  sitekey: string;
}) {
  const w = window as any;

  // Si ya existe, solo actualizamos propiedades
  if (w.interdeal) {
    w.interdeal.hideBtn = hideBtn;
    w.interdeal.Position = position;
    w.interdeal.Menulang = lang;
    return;
  }

  w.interdeal = {
    hideBtn,
    get sitekey() {
      return sitekey;
    },
    get domains() {
      return {
        js: 'https://cdn.equalweb.com/',
        acc: 'https://access.equalweb.com/',
      };
    },
    Position: position,
    Menulang: lang,
    draggable: false,
    showTooltip: true,
    btnStyle: {
      vPosition: ['calc(100% - 150px)', 'calc(100% - 145px)'],
      margin: ['5px', '-6px'],
      scale: ['0.49', '0.48'],
      color: {
        main: '#000000',
        second: '#ffffff',
      },
      icon: {
        outline: false,
        outlineColor: '#ffffff',
        type: 11,
        shape: 'circle',
      },
    },
  };

  if (scriptLoaded) return;

  const script = document.createElement('script');
  script.src = 'https://cdn.equalweb.com/core/5.2.0/accessibility.js';
  script.defer = true;
  script.integrity =
    'sha512-fHF4rKIzByr1XeM6stpnVdiHrJUOZsKN2/Pm0jikdTQ9uZddgq15F92kUptMnyYmjIVNKeMIa67HRFnBNTOXsQ==';
  script.crossOrigin = 'anonymous';
  script.setAttribute('data-cfasync', 'true');

  document.body.appendChild(script);
  scriptLoaded = true;
}
